<template>
  <div>
    <VueSignaturePad height="300px" ref="signaturePad" :options="options" />
    <div class="d-flex justify-space-between">
      <v-btn @click="clear">{{$t('drSignaturePad.clear')}}</v-btn>
      <v-btn @click="save">{{$t('drSignaturePad.save')}}</v-btn>
    </div>
  </div>
</template>

<script>
import uk from '../../langs/signaturePad/uk.json'
import ru from '../../langs/signaturePad/ru.json'
import en from '../../langs/signaturePad/en.json'
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  name: 'dr-signature-pad-component',
  components: {
    'VueSignaturePad': () => import(/* webpackChunkName: "chunk_signature-pad" */'./vue-signature-pad.vue')
  },
  mixins: [mixin, inputMixin],
  computed: {
    options() {
      return { backgroundColor: this.model.Color || '#ffffff' }
    }
  },
  methods: {
    clear() {
      this.$refs.signaturePad.clearSignature()
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      // eslint-disable-next-line no-console
      console.log(isEmpty)

      let blobBin = atob(data.split(',')[1])
      let array = []
      for (let i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i))
      }
      let file = new Blob([new Uint8Array(array)], { type: 'image/png' })

      let formData = new FormData()
      formData.append('file', file, 'signature.png')

      fetch(window.appConfig.GraphQlUrl + 'upload', {
        method: 'POST',
        body: formData,
        headers: {
          'Upload-Type': 'single'
        }
      })
        .then((response) => response.json())
        .then((r) => {
          if (this.model.Value) {
            this.setDataSourceField(this.model.Value, r.fileName)
          }
          if (this.model.OnClickAction) {
            this.$emit('callDataSourceAction', {
              action: this.model.OnClickAction,
              params: r
            })
          }
        })
    }
  },
  i18n: {
    messages: {
      uk,
      en,
      ru
    }
  }
}
</script>
